import RenderComponent from '@/modules/DynamicRenderPage';
import { useTheme } from '@material-ui/core/styles';
import { getQueryStringKeys, loadPageConfig, loadStyle } from 'globalutils/fmUtils';
import React, { lazy, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { sortColumnMapping } from './config';
import ParentStyled from './style';

const config = loadPageConfig();
const Styled = loadStyle(ParentStyled, 'pages/web/QuickStats');
const Title = lazy(() => import(`globalcomponents/Title`));
const Content = lazy(() => import(`@/${config.quickStats[1].name}`));

const QuickStats = (parentProps) => {
  const { fetchQuickStats } = parentProps;
  const [pagination, setPagination] = useState(false);

  const history = useHistory();

  const [request, setRequest] = useState({
    displayLength: '15',
    displayStart: '1',
  });

  const theme = useTheme();
  const { t: i18n } = useTranslation();
  const commonParentProps = { history, i18n, Styled, theme };

  const changeRequest = (fields) => {
    if (fields?.sortCol) {
      const type = fields.sortCol;
      fields.sortCol = sortColumnMapping[type] ? sortColumnMapping[type] : fields.sortCol;
    }
    setRequest((prevRequest) => ({
      ...prevRequest,
      ...fields,
    }));
  };

  useEffect(() => {
    let req = JSON.parse(JSON.stringify(request));
    delete req.period;
    fetchQuickStats({
      apiId: 'fetchQuickStatsApi',
      data: {
        request: req,
        period: request.period || getQueryStringKeys(history.location.search, 'period'),
        event: getQueryStringKeys(history.location.search, 'event'),
        companyId: getQueryStringKeys(history.location.search, 'companyId'),
      },
    });
  }, [request, fetchQuickStats, history]);

  return (
    <>
      <RenderComponent
        {...config.quickStats[0]}
        parentProps={parentProps}
        commonParentProps={commonParentProps}
        component={Title}
      />
      <RenderComponent
        {...config.quickStats[1]}
        parentProps={{
          ...parentProps,
          changeRequest,
          request,
          pagination,
          setPagination,
        }}
        commonParentProps={commonParentProps}
        component={Content}
        pagination={pagination}
        setPagination={setPagination}
      />
    </>
  );
};

const mapState = (state) => ({
  apiStatus: state.asyncRequests,
  paginateList: state.scoreCard.quickStatsList,
  filters: state.filters,
});

const mapDispatch = (dispatch) => {
  return {
    fetchQuickStats: (data) => dispatch.scoreCard.fetchQuickStatsList(data),
  };
};

export default connect(mapState, mapDispatch)(QuickStats);
